import { runClientComponent } from '../../_common/client/client-component-runner';
import { RecoComplementaryComponent } from './reco-complementary.component';

runClientComponent({ RecoComplementaryComponent });
